import script from "./CandidateShopProductsShow.vue?vue&type=script&setup=true&lang=js"
export * from "./CandidateShopProductsShow.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__